import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-transaction-total-disount-rate-dialog',
  templateUrl: './transaction-total-disount-rate-dialog.component.html',
  styleUrls: ['./transaction-total-disount-rate-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TransactionTotalDisountRateDialogComponent implements OnInit {
  discountRateForm: FormGroup;

  constructor(
    public ngbModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastrService: ToastrService
  ) { }

  ngOnInit() {
    this.discountRateForm = this.fb.group({
      discountRate: [
        null,
        [Validators.required, Validators.max(100), Validators.min(0)]
      ]
    });
  }

  onSubmit() {
    if (this.discountRateForm.invalid) {
      this.toastrService.error("İndirim oranı giriniz, boş bırakmayın.", "İndirim Uyarısı!");
      this.discountRateForm.markAllAsTouched(); // tüm alanları touched yap
      return;
    }

    this.toastrService.success("İndirim oranı başarıyla kaydedildi.", "İndirim Uyarısı!");
    this.ngbModal.close(this.discountRateForm.value.discountRate);
  }

  closeModal(result: boolean = false) {
    this.ngbModal.close(result);
  }
}
